import React from "react";
import styles from "./styles.m.css";
import assetify from "@quintype/framework/assetify";
import NotFoundImage from "../../../../assets/images/not-found-image.png";
import { DfpAd } from "../../atoms/dfp-ad";
import { PAGE_TYPE } from "../../../constants";
import { GA, Chartbeat } from "../../../integrations";

const NotFoundPage = () => {
  React.useEffect(() => {
    GA.registerPageView(PAGE_TYPE.NOT_FOUND);
    Chartbeat.registerNonStoryPageView(PAGE_TYPE.NOT_FOUND);
  }, []);
  return (
    <div className="main-page">
      <DfpAd className="hidden-mobile ad-tower-left" adtype="Tower_Left" placement="all" />
      <div className={styles.base}>
        <div className={`container`}>
          <div className={styles["page-404"]}>
            <img src={assetify(NotFoundImage)} />
            <h1 className={styles.headline}>{`We are unable to find the page you're looking for.`}</h1>
            <p className={styles["sub-text"]}>
              {`Try exploring the navigation links above to locate what you're after, or use the search box at the top of
            the page.`}
            </p>
          </div>
        </div>
      </div>
      <DfpAd className="hidden-mobile ad-tower-right" adtype="Tower_Right" placement="all" />
    </div>
  );
};

export { NotFoundPage };
